'use strict';

module.exports = {
    prependSlot: 'prependSlot',
    slotUpperLeft: 'slotUpperLeft',
    slotLowerLeft: 'slotLowerLeft',
    slotUpperRight: 'slotUpperRight',
    slotLowerRight: 'slotLowerRight',
};
